import { TStoreState } from 'redux/types';

export const getEmVatReportsList = (state: TStoreState) => state.emVatReports.emVatReportsList;
export const getEmVatReportsListLoading = (state: TStoreState) =>
	state.emVatReports.emVatReportsListLoading;
export const getEmVatReportDownloadLoading = (state: TStoreState) =>
	state.emVatReports.emVatReportDownloadLoading;
